module.exports = __webpack_public_path__ + "img/aiverse_aiverse.b632196.png";